import { forwardRef } from 'react';

import { IconProps } from '.';

export const MapIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M11.52 8.79002C11.52 9.62949 10.8395 10.31 10 10.31C9.16053 10.31 8.48 9.62949 8.48 8.79002C8.48 7.95055 9.16053 7.27002 10 7.27002C10.8395 7.27002 11.52 7.95055 11.52 8.79002Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.01904C11.7315 2.01904 13.3966 2.68542 14.65 3.88C15.2912 4.53425 15.7964 5.30916 16.1363 6.15989C16.4761 7.01062 16.6439 7.92029 16.63 8.83629C16.616 9.75229 16.4206 10.6564 16.055 11.4964C15.6894 12.3364 15.1609 13.0956 14.5 13.73L10.5 17.73C10.3594 17.8704 10.1688 17.9493 9.97 17.9493C9.77125 17.9493 9.58063 17.8704 9.44 17.73L5.44 13.73C4.78312 13.0916 4.25933 12.3292 3.89892 11.4871C3.53851 10.645 3.34862 9.73975 3.34026 8.82377C3.33189 7.90779 3.50519 6.99924 3.85016 6.15067C4.19512 5.30209 4.7049 4.53032 5.35 3.88C6.60342 2.68542 8.26851 2.01904 10 2.01904ZM6.47 12.64L10 16.17L13.61 12.64C14.1225 12.1373 14.5296 11.5374 14.8075 10.8755C15.0855 10.2136 15.2286 9.50289 15.2286 8.785C15.2286 8.0671 15.0855 7.35641 14.8075 6.69449C14.5296 6.03257 14.1225 5.43271 13.61 4.93C12.6425 4.02306 11.3661 3.51834 10.04 3.51834C8.71389 3.51834 7.43749 4.02306 6.47 4.93C5.9575 5.43271 5.55039 6.03257 5.27247 6.69449C4.99455 7.35641 4.8514 8.0671 4.8514 8.785C4.8514 9.50289 4.99455 10.2136 5.27247 10.8755C5.55039 11.5374 5.9575 12.1373 6.47 12.64Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default MapIcon;
